import {m} from 'framer-motion'
import {FC} from 'react'

import {HEADER_LOGO_TRANSITION} from '@/theme/cssTransitions'
import {HEADER_CONTENT_HEIGHT_MOBILE} from '@/theme/sizing'
import {useUniqueClassName} from '@/utils/hooks/useUniqueClassName'
import {useIsScrolledPast} from '@/utils/ui/hooks/useIsScrolledPast'

import {HeaderMainButton, HeaderMainButtonProps} from '../HeaderMainButton'
import {HeaderLogo} from './HeaderLogo'

type HeaderLogoWithCTAProps = {
  mainCtaButton: HeaderMainButtonProps
}

export const HeaderLogoWithCTA: FC<HeaderLogoWithCTAProps> = ({mainCtaButton}) => {
  const className = useUniqueClassName('header-logo-with-cta')
  const isScrolledPast = useIsScrolledPast()

  return (
    <>
      <div className={className}>
        <m.div
          animate={
            isScrolledPast
              ? {y: '-100%', transitionEnd: {visibility: 'hidden'}}
              : {y: 0, visibility: 'visible'}
          }
          initial={false}
          transition={{duration: HEADER_LOGO_TRANSITION, ease: 'easeOut'}}
          className={`${className}-item`}
        >
          <HeaderLogo />
        </m.div>
        <m.div
          animate={
            isScrolledPast
              ? {y: '-100%', visibility: 'visible'}
              : {y: '100%', transitionEnd: {visibility: 'hidden'}}
          }
          initial={false}
          transition={{duration: HEADER_LOGO_TRANSITION, ease: 'easeOut'}}
          className={`${className}-item`}
        >
          <HeaderMainButton {...mainCtaButton} />
        </m.div>
      </div>

      <style jsx global>{`
        .${className} {
          height: ${HEADER_CONTENT_HEIGHT_MOBILE};
        }
        .${className}-item {
          display: flex;
          align-items: center;
          height: 100%;
        }
      `}</style>
    </>
  )
}
